/**
 * 联系销售
 */
import React, { useState } from 'react';
import { WhitePaper } from '../whitePaperCommon/whitePaper';

interface IProp {
    referUrl: string;
}
interface ICmsProps {
    referUrl: string;
    platform: 'twww' | 'mobile'; // 平台
    hasSubmitted: boolean;
}
export function App(props: IProp) {
    const cmsInfo: ICmsProps = {
        referUrl: props.referUrl,
        platform: 'twww',
        hasSubmitted: false,
    };
    const [state, setState] = useState({ cmsInfo });
    const changeHasSubmitted = (value: boolean) => {
        const _cmsInfo = state.cmsInfo;
        _cmsInfo.hasSubmitted = value;
        setState({ cmsInfo: _cmsInfo });
        console.log('hasSubmitted', state);
    };
    return (
        <div className="cms-history-index-page">
            <WhitePaper changeHasSubmitted={changeHasSubmitted} {...state.cmsInfo}></WhitePaper>
        </div>
    );
}
